import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LicenseAgreementGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let loginData: any = localStorage.getItem('websiteUser');
    const websiteUser = JSON.parse(loginData);
    if (websiteUser?.show_license_agreement) {
      return this.router.navigate(['/website/license-agreement'], {
        queryParams: { gate: true },
      });
    }
    return true;
  }
}
